module.exports = __webpack_public_path__ + "static/media/20180523-LCS-007-19.3b0c06f5.jpg";